import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { h1style } from '../../../components/H1';
import PageHeader from '../../../components/PageHeader';
import Row from '../../../components/Row';
import { META_DEFAULT_IMAGE } from '../../App/constants';
import {
  ARTICLE,
  CATEGORY,
  HELMET_TITLE,
  questionPropTypes,
} from '../constants';
import ArticlePage from './ArticlePage';
import CategoryPage from './CategoryPage';
import MainPage from './MainPage';
import messages, { faqMessages } from './messages';
import StickyMenu from './StickyMenu';

const Container = styled.div`
  ${tw`relative`};
`;

const FaqMainHeader = styled.p`
  ${h1style}
  ${tw`cursor-pointer`}
`;

const FlexContent = styled(Row)`
  ${tw`flex flex-col-reverse lg:flex-row`};
`;

const FaqView = ({
  articlesList,
  categoryName,
  intl,
  locale,
  pageContent,
  pageType,
  redirectHome,
  relatedQuestions,
  resetState,
}) => {
  return (
    <Container>
      {!pageType ? (
        <Helmet>
          <title>{HELMET_TITLE}</title>
          <meta content={HELMET_TITLE} property="og:title" />
          <meta
            content={intl.formatMessage(faqMessages.metaDescription)}
            property="description"
          />
          <meta
            content={intl.formatMessage(faqMessages.metaDescription)}
            property="og:description"
          />
        </Helmet>
      ) : (
        <Helmet>
          <title>{pageContent.meta.title}</title>
          <meta content={pageContent.meta.description} name="description" />
          <meta content={pageContent.meta.title} property="og:title" />
          <meta
            content={pageContent.meta.description}
            property="og:description"
          />
          <meta content={window.location.href} property="og:url" />
          <meta content={META_DEFAULT_IMAGE} property="og:image" />
        </Helmet>
      )}
      <PageHeader>
        <FaqMainHeader id="redirectHome" onClick={() => redirectHome()}>
          <FormattedMessage {...messages.header} />
        </FaqMainHeader>
      </PageHeader>
      <FlexContent>
        <StickyMenu
          categoryName={categoryName}
          locale={locale}
          redirectHome={redirectHome}
        />
        {!pageType && <MainPage locale={locale} />}
        {pageType === CATEGORY && (
          <CategoryPage
            articlesList={articlesList}
            category={pageContent}
            resetState={resetState}
          />
        )}
        {pageType === ARTICLE && (
          <ArticlePage
            article={pageContent}
            categoryName={categoryName}
            relatedQuestions={relatedQuestions}
          />
        )}
      </FlexContent>
    </Container>
  );
};

FaqView.propTypes = {
  articlesList: PropTypes.arrayOf(questionPropTypes),
  categoryName: PropTypes.string,
  intl: PropTypes.object,
  locale: PropTypes.string,
  pageContent: questionPropTypes,
  pageType: PropTypes.string,
  redirectHome: PropTypes.func,
  relatedQuestions: PropTypes.arrayOf(questionPropTypes),
  resetState: PropTypes.func,
};

export default injectIntl(FaqView);
